import api from './api';

export const loginApi = params => {
  return api.post('/auth', params);
};

export const getProfileApi = () => {
  return api.get('/users/profile');
};

export const editProfileApi = params => {
  return api.put('/users/profile', params);
};

export const forgotPasswordApi = email => {
  return api.post('/users/forgot-password', {email});
};

export const verifyToken = token => {
  return api.get(`/users/verify/${token}`);
};

export const resetPassword = (token, password, confirmPassword) => {
  return api.put(`/users/${token}/new-password`, {password, confirmPassword});
};

export const updatePasswordApi = (oldPassword, password, confirmPassword) => {
  return api.put('/users/update-password', {
    oldPassword,
    password,
    confirmPassword,
  });
};

export const updateEmailApi = email => {
  return api.put('/users/profile/email', {email});
};
